import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Java Store Management System"
              description="This project involves the design and development of a software system for The Cosmetic Store to automate their stock management. The main objective of this project was to apply fundamental OOP concepts—including Object, Class, Abstraction, Inheritance, Encapsulation, and Polymorphism—to create a robust application that manages product information effectively.!"
              ghLink="https://github.com/Kalana8/cosmetics-store-management-system.git"
              demoLink="https://github.com/Kalana8/cosmetics-store-management-system.git"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Bits-0f-C0de"
              description="My Test Portfolio website build with Node.js and  Css which takes the content from makdown files and renders it using React.js."
              ghLink="https://668a9d5c95ebaf9e1b699a99--kalanak.netlify.app/"
              demoLink="https://668a9d5c95ebaf9e1b699a99--kalanak.netlify.app/"
            />
          </Col>

          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
